// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1HiNNgtXwsvCzFI3a4zS9s"};